module.exports = __webpack_public_path__ + "static/media/securePay.f13b812b.png";